/*
 * Bold Upsell AJAX bridge
 * ------------------------
 * This theme adds to cart over AJAX (product-form.js calls evt.preventDefault()
 * and fetches /cart/add.js), so Bold Upsell never sees a real add-to-cart and
 * its popup never triggers. Per Bold's AJAX-cart install guide, the theme must
 * emit Bold's events after the cart is rebuilt. We hook the theme's own
 * pub/sub "cart-update" event (published by product-form.js on a successful add)
 * and forward it to Bold's event emitter.
 * Guide: https://support.boldcommerce.com/boldupsell/bold-upsell-legacy/installation-guide-for-bold-upsell
 */
(function () {
  function boldReady() {
    return (
      typeof BOLD === 'object' &&
      BOLD.common &&
      BOLD.common.eventEmitter &&
      typeof BOLD.common.eventEmitter.emit === 'function'
    );
  }

  function notifyBold(isAddToCart) {
    if (!boldReady()) return;
    BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    // Only pop the upsell modal on an actual add-to-cart, not on quantity edits.
    if (isAddToCart) {
      BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
    }
  }

  function bindCartUpdate() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      return false;
    }
    // Sources that represent a real add-to-cart (vs. 'cart-items' quantity edits).
    const ADD_SOURCES = ['product-form', 'quick-add'];
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const isAddToCart = !!event && ADD_SOURCES.indexOf(event.source) !== -1;
      notifyBold(isAddToCart);
      guardFreeShaker();
    });
    return true;
  }

  /*
   * Halloween sale (Oct 30 to Nov 1 2026): the Bold "Free Shaker" offer is for carts of
   * $75+. Bold's own auto-remove only works with Bold-discounted products, so
   * when the cart drops under the minimum we remove the free shaker ourselves.
   * Remove this block (and the constants) after the sale.
   */
  const FREE_SHAKER_VARIANT_ID = 46967274569903;
  const FREE_SHAKER_MIN_CENTS = 7500;
  const FREE_SHAKER_GUARD_UNTIL = Date.parse('2026-11-02T00:00:00-05:00');
  let shakerGuardBusy = false;

  function guardFreeShaker() {
    if (shakerGuardBusy || Date.now() > FREE_SHAKER_GUARD_UNTIL) return;
    shakerGuardBusy = true;
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const shaker = cart.items.find((i) => i.variant_id === FREE_SHAKER_VARIANT_ID);
        if (!shaker) return;
        const rest = cart.items
          .filter((i) => i.variant_id !== FREE_SHAKER_VARIANT_ID)
          .reduce((sum, i) => sum + i.final_line_price, 0);
        if (rest >= FREE_SHAKER_MIN_CENTS) return;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(FREE_SHAKER_VARIANT_ID), quantity: 0 }),
        })
          .then((r) => r.json())
          .then((updated) => {
            // Re-render the drawer/cart page (source != 'cart-items' triggers a refresh).
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-shaker-guard' });
            // The refresh does not touch the drawer header count or the bubble.
            const n = Number(updated.item_count) || 0;
            const countEl = document.querySelector('.drawer__item-count');
            if (countEl) {
              countEl.textContent = countEl.textContent
                .replace(/\d+/, n)
                .replace(/items?/i, n === 1 ? 'item' : 'items');
            }
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.updateCartBubble === 'function') drawer.updateCartBubble(n);
          });
      })
      .catch(() => {})
      .finally(() => {
        shakerGuardBusy = false;
      });
  }

  // subscribe()/PUB_SUB_EVENTS come from pubsub.js/constants.js; retry briefly
  // in case this script executes before they are defined.
  if (!bindCartUpdate()) {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (bindCartUpdate() || attempts >= 40) clearInterval(timer);
    }, 100);
  }
})();
